module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "p-5 darker"
  }, [_c('div', {
    staticClass: "col-md-12 text-right mb-4"
  }, [_c('input', {
    staticClass: "btn widest ml-auto",
    attrs: {
      "type": "submit",
      "value": "Save"
    },
    on: {
      "click": _vm.save
    }
  })]), _vm._v(" "), (_vm.accordions[0].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(0)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Check-in")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[0].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[0].isOpen && _vm.accordions[0].enabled) ? _c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-4 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                Location to check-in\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.location.name),
      expression: "presets.location.name"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.presets.location.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets.location, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                Latitude\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.location.latitude),
      expression: "presets.location.latitude"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.presets.location.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets.location, "latitude", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 mb-2"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                Longitude\n                "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.location.longitude),
      expression: "presets.location.longitude"
    }],
    staticClass: "bg-lighter",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.presets.location.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets.location, "longitude", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[1].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(1)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Direct Sales - Payment and Deposit")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[1].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[1].isOpen && _vm.accordions[1].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Payment\n                ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getRequirePaymentOptions,
      "label": "description"
    },
    on: {
      "input": _vm.setPaymentDepositType
    },
    model: {
      value: (_vm.paymentDepositType),
      callback: function($$v) {
        _vm.paymentDepositType = $$v
      },
      expression: "paymentDepositType"
    }
  })], 1), _vm._v(" "), (_vm.presets.paymentDepositType && _vm.presets.paymentDepositType == 2) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Deposit\n                ")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "options": _vm.getDepositOptions,
      "label": "description"
    },
    on: {
      "input": _vm.setDepositType
    },
    model: {
      value: (_vm.depositType),
      callback: function($$v) {
        _vm.depositType = $$v
      },
      expression: "depositType"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fs-smaller dark"
  }, [_vm._v("This is the deposit that the customer must pay at the time of booking.")])], 1) : _vm._e(), _vm._v(" "), (_vm.presets.paymentDepositType && _vm.presets.paymentDepositType == 2 && _vm.depositType && _vm.depositType.id != 2) ? _c('div', {
    staticClass: "col-md-2 mb-2 d-flex justify-content-end"
  }, [_c('label', {
    staticClass: "full"
  }, [_vm._v("\n                    Amount\n                    "), _c('div', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.depositValue),
      expression: "presets.depositValue"
    }],
    staticClass: "glued-right bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.presets.depositValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "depositValue", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.presets.depositType == 0) ? _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("€")]) : _vm._e(), _vm._v(" "), (_vm.presets.depositType == 1) ? _c('div', {
    staticClass: "glued-left"
  }, [_vm._v("%")]) : _vm._e()])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.accordions[2].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(2)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Cancellation rules")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[2].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[2].isOpen && _vm.accordions[2].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row px-5 mb-3"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Direct - In person")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex"
  }, [_c('input', {
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "w-50",
    attrs: {
      "value": "Minutes",
      "options": ['Minutes', 'Hours']
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row px-5 mb-3"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Phone")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex"
  }, [_c('input', {
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "w-50",
    attrs: {
      "value": "Minutes",
      "options": ['Minutes', 'Hours']
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row px-5 mb-3"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex"
  }, [_c('input', {
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "w-50",
    attrs: {
      "value": "Minutes",
      "options": ['Minutes', 'Hours']
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row px-5 mb-3"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("Website")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 d-flex"
  }, [_c('input', {
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    }
  }), _vm._v(" "), _c('v-select', {
    staticClass: "w-50",
    attrs: {
      "value": "Minutes",
      "options": ['Minutes', 'Hours']
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.accordions[3].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(3)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Commissions")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[3].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[3].isOpen && _vm.accordions[3].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "row px-5 mb-3 align-items-start"
  }, [_c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-12 darkest font-weight-600"
  }, [_vm._v("Agents")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Products - Commission by default\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.commissionAgentsProduct),
      expression: "presets.commissionAgentsProduct"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.presets.commissionAgentsProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "commissionAgentsProduct", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Extras - Commission by default\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.commissionAgentsComponent),
      expression: "presets.commissionAgentsComponent"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.presets.commissionAgentsComponent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "commissionAgentsComponent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Pickups - Commission by default\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.commissionAgentsTransport),
      expression: "presets.commissionAgentsTransport"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.presets.commissionAgentsTransport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "commissionAgentsTransport", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "col-md-12 darkest font-weight-600"
  }, [_vm._v("My Team - Sellers")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Products - Commission by default\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.commissionMyTeamProduct),
      expression: "presets.commissionMyTeamProduct"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.presets.commissionMyTeamProduct)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "commissionMyTeamProduct", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Extras - Commission by default\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.commissionMyTeamComponent),
      expression: "presets.commissionMyTeamComponent"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.presets.commissionMyTeamComponent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "commissionMyTeamComponent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                        Pickups - Commission by default\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.commissionMyTeamTransport),
      expression: "presets.commissionMyTeamTransport"
    }],
    staticClass: "glued-right w-50 bg-lighter",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.presets.commissionMyTeamTransport)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "commissionMyTeamTransport", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark w-25"
  }, [_vm._v("%")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[4].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(4)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Discounts")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[4].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[4].isOpen && _vm.accordions[4].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                    Exclude transport from discounts\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.presets.excludeTransportFromDiscounts),
      callback: function($$v) {
        _vm.$set(_vm.presets, "excludeTransportFromDiscounts", $$v)
      },
      expression: "presets.excludeTransportFromDiscounts"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                    Exclude extras from discounts\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.presets.excludeExtraFromDiscounts),
      callback: function($$v) {
        _vm.$set(_vm.presets, "excludeExtraFromDiscounts", $$v)
      },
      expression: "presets.excludeExtraFromDiscounts"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[5].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(5)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Agents Permissions")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[5].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[5].isOpen && _vm.accordions[5].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                    Agents have access to Extras\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.presets.agentsHaveAccessExtras),
      callback: function($$v) {
        _vm.$set(_vm.presets, "agentsHaveAccessExtras", $$v)
      },
      expression: "presets.agentsHaveAccessExtras"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                    Agents have access to Pickups\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.presets.agentsHaveAccessPickups),
      callback: function($$v) {
        _vm.$set(_vm.presets, "agentsHaveAccessPickups", $$v)
      },
      expression: "presets.agentsHaveAccessPickups"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[6].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(6)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Widget Permissions")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[6].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[6].isOpen && _vm.accordions[6].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "col-md-6 row"
  }, [_c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                    Widget have access to Extras\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.presets.widgetHaveAccessExtras),
      callback: function($$v) {
        _vm.$set(_vm.presets, "widgetHaveAccessExtras", $$v)
      },
      expression: "presets.widgetHaveAccessExtras"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row m-0 mb-3 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_vm._v("\n                    Widget have access to Pickups\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex justify-content-end"
  }, [_c('toggle-button', {
    staticClass: "mr-3",
    attrs: {
      "value": true,
      "sync": true,
      "labels": {
        checked: 'YES',
        unchecked: 'NO'
      }
    },
    model: {
      value: (_vm.presets.widgetHaveAccessPickups),
      callback: function($$v) {
        _vm.$set(_vm.presets, "widgetHaveAccessPickups", $$v)
      },
      expression: "presets.widgetHaveAccessPickups"
    }
  })], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.accordions[7].enabled) ? _c('div', {
    staticClass: "pointer d-flex flex-row justify-content-between align-items-center border-bottom-medium mb-3",
    on: {
      "click": function($event) {
        return _vm.toggleAccordion(7)
      }
    }
  }, [_c('span', {
    staticClass: "darker font-weight-600"
  }, [_vm._v("Sales")]), _vm._v(" "), _c('i', {
    staticClass: "ico-arrow-bottom larger pointer color-6",
    class: {
      'ico-arrow-top': _vm.accordions[7].isOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.accordions[7].isOpen && _vm.accordions[7].enabled) ? _c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-6 d-flex justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex align-items-center  w-100"
  }, [_c('label', {
    staticClass: "full darkest"
  }, [_vm._v("\n                    Charge total amount for product higher than  \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex ml-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.presets.chargeTotalAmount),
      expression: "presets.chargeTotalAmount"
    }],
    staticClass: "glued-right bg-lighter",
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.presets.chargeTotalAmount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.presets, "chargeTotalAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "glued-left dark"
  }, [_vm._v("€")])])])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row mb-5 mt-4"
  }, [_c('div', {
    staticClass: "col-md-12 darker font-weight-600"
  }, [_vm._v("Time before event for automatic cancellation:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row m-0 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 dark font-weight-600 fs-small text-center"
  }, [_vm._v("\n                        Commission\n                    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row m-0 align-items-center w-100"
  }, [_c('div', {
    staticClass: "col-md-8"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 dark font-weight-600 fs-small text-center"
  }, [_vm._v("\n                        Commission\n                    ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-a2b6fcbc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a2b6fcbc"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/TabPresets.vue
// module id = 1550
// module chunks = 0